import React, { Component } from "react";
import { connect } from "react-redux";
import "react-bootstrap";
import Modal from "react-modal";

import * as apiConstant from "../api/apiConstant";
import bannerApi from "../api/bannerApi";
import envApi from "../api/envApi";
import { lang } from "../config/lang";
import { BS_CATEGORY, Pages } from "../config/Helper";
import store from "../store/configureStore";
import { addNotification } from "../actions/notificationAction";
import { stepEditStyle } from "../config/style";
import $ from "jquery/dist/jquery.js";
import { setTimeout } from "timers";
import topBanner from "../reducers/topBannerReducer";
import {
    setBusinessAction,
    setSearchKeyAction,
} from "../actions/topBannerAction";
import * as UTILS from "../config/utils";

/****************************************
    Component for Top Banner of a page
    @author  IMH003
    @date    2020.05.10
    @version 0.1    
 ******************************************/
class TopBanner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            backIndex: 0,
            back_img_urls: [],
            back_img_url: "",
            title: "",
            sub_title: "",
            contentModalIsOpen: false,
            aboutInfo: "",
            business: "all",
            searchKey: "",
            category: "all",
        };

        this.orders = 1;
        this.page = "";
        this.showSearch = false;
        this.isHome = true;

        this.initStellar = this.initStellar.bind(this);
        this.afterContentModal = this.afterContentModal.bind(this);
        this.closeContentModal = this.closeContentModal.bind(this);
        this.onClickAbout = this.onClickAbout.bind(this);
        this.getBanner = this.getBanner.bind(this);
        this.getAboutInfo = this.getAboutInfo.bind(this);
        this.onBsChange = this.onBsChange.bind(this);
        this.onCategoryChange = this.onCategoryChange.bind(this);
        this.onHandleKeyChange = this.onHandleKeyChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onHandleKeyDown = this.onHandleKeyDown.bind(this);
        this.onHandleClick = this.onHandleClick.bind(this);
    }

    componentDidMount() {
        window.bannerTimer = setInterval(() => {
            if (this.state.backIndex + 1 >= this.state.back_img_urls.length)
                this.setState({ backIndex: 0 });
            else
                this.setState({
                    backIndex: this.state.backIndex + 1,
                });
        }, 5000);
    }

    componentWillUnmount() {
        window.destroyStellar();
        clearInterval(window.bannerTimer);
    }

    componentDidUpdate() {
        window.InitAOS();
        const reduxStore = store.getState();
        if (
            !!reduxStore.topBanner.business &&
            this.state.business !== reduxStore.topBanner.business
        ) {
            this.setState({
                ...this.state,
                business: reduxStore.topBanner.business,
            });
        }
    }

    componentWillReceiveProps(newProps) {
        if (
            newProps.language.lang_key !== this.props.language.lang_key ||
            newProps.topBanner.page !== this.page ||
            newProps.topBanner.showSearch !== this.showSearch ||
            newProps.topBanner.isHome !== this.isHome
        ) {
            if (this.page !== newProps.topBanner.page) {
                if (this.page !== "" && newProps.topBanner.page === "") {
                    window.destroyStellar();
                }

                if (this.page === "" && newProps.topBanner.page !== "") {
                    setTimeout(this.initStellar, 800);
                }
            }

            this.page = newProps.topBanner.page;
            this.showSearch = newProps.topBanner.showSearch;
            this.isHome = newProps.topBanner.isHome;
            this.getBanner(false);
        }
        // const reduxStore = store.getState();
        // if (!!newProps.topBanner.onSearch && newProps.topBanner.searchKey !== this.props.topBanner.searchKey) {
        //     newProps.topBanner.onSearch(newProps.topBanner.searchKey, reduxStore.topBanner.business || this.state.business, this.state.category);
        // }

        const reduxStore = store.getState();
        // console.log(this.props.topBanner.business, reduxStore.topBanner.business)

        if (!!newProps.topBanner.onSearch && reduxStore.topBanner.business) {
            newProps.topBanner.onSearch(
                newProps.topBanner.searchKey
                    ? newProps.topBanner.searchKey
                    : "",
                reduxStore.topBanner.business,
                this.state.category
            );
        }
    }

    initStellar() {
        window.initStellar();
    }

    afterContentModal() {}

    closeContentModal() {
        this.setState({
            modal_info: {},
            contentModalIsOpen: false,
        });
    }

    onClickAbout() {
        this.getAboutInfo();
        this.setState({
            contentModalIsOpen: true,
        });
    }

    getBanner(willShowPreloader) {
        bannerApi
            .getBanner(Pages.indexOf(this.page), this.orders)
            .then((json) => {
                if (json.status === 200 && json.data.length) {
                    this.setState({
                        backIndex: 0,
                        back_img_urls: json.data,
                        back_img_url: json.data[0].file_path,
                        title: json.data[0].title,
                        sub_title: json.data[0].description,
                    });
                } else if (json.status === 200 && json.data === "") {
                    this.setState({
                        backIndex: 0,
                        back_img_urls: [],
                        back_img_url: "",
                        title: "",
                        sub_title: "",
                    });
                } else if (json.status !== 200) {
                    store.dispatch(
                        addNotification(`${lang("server_err")}...`, "error")
                    );
                }
            });
    }

    getAboutInfo() {
        envApi.getAboutUs().then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    aboutInfo: json.data,
                });
            } else if (json.status !== 200) {
                store.dispatch(
                    addNotification(`${lang("server_err")}...`, "error")
                );
            }
        });
    }

    onBsChange(event) {
        this.setState({
            ...this.state,
            business: event.target.value,
        });
        store.dispatch(setBusinessAction(event.target.value));
        var search = this.checkSearchKey(this.state.searchKey);
        if (!search && this.state.searchKey !== "")
            store.dispatch(
                addNotification(`${lang("search_key_err")}`, "error")
            );
        else
            this.onSearch(
                this.state.searchKey,
                event.target.value,
                this.state.category
            );
    }

    onCategoryChange(event) {
        this.setState({
            ...this.state,
            category: event.target.value,
        });
        var search = this.checkSearchKey(this.state.searchKey);
        if (!search && this.state.searchKey !== "")
            store.dispatch(
                addNotification(`${lang("search_key_err")}`, "error")
            );
        else
            this.onSearch(
                this.state.searchKey,
                this.state.business,
                event.target.value
            );
    }

    checkSearchKey(str) {
        var patt = new RegExp(/[@#!$%^&*~{}|><"/+_()]/g);
        if (str === "" || str.indexOf(" ") === 0) return false;
        if (patt.test(str)) {
            return false;
        } else {
            return true;
        }
    }

    onHandleKeyChange(event) {
        store.dispatch(setSearchKeyAction(event.target.value));
        this.setState({
            ...this.state,
            searchKey: event.target.value,
        });
    }

    onSearch(key, business, category) {
        var search = this.checkSearchKey(key);
        // if (!search) store.dispatch(addNotification(`${lang('search_key_err')}`, 'error'));
        if (key === "" || search)
            this.props.topBanner.onSearch(key, business, category);
        // if(key === '') this.props.topBanner.onSearch(key, business, category);
    }

    onHandleKeyDown(event) {
        if (event.key === "Enter") {
            store.dispatch(setSearchKeyAction(this.state.searchKey));
            const search_key = store.getState().topBanner.searchKey;
            var search = this.checkSearchKey(search_key);
            if (!search)
                store.dispatch(
                    addNotification(`${lang("search_key_err")}`, "error")
                );
            else
                this.onSearch(
                    search_key,
                    this.state.business,
                    this.state.category
                );
        }
    }

    onHandleClick() {
        store.dispatch(setSearchKeyAction(this.state.searchKey));
        const search_key = store.getState().topBanner.searchKey;
        var search = this.checkSearchKey(search_key);
        if (!search)
            store.dispatch(
                addNotification(`${lang("search_key_err")}`, "error")
            );
        else
            this.onSearch(search_key, this.state.business, this.state.category);
    }

    render() {
        if (this.page === "") {
            return <div></div>;
        }
        var banner_back_url = "none";

        // let index = this.state.back_img_urls.length === 0 ? 0 : this.state.backIndex % this.state.back_img_urls.length

        let back_img_url = this.state.back_img_urls[this.state.backIndex];

        // if (this.state.back_img_url.length > 0) {
        //     banner_back_url = `url('${apiConstant.bannerURL(this.state.back_img_url)}')`;
        // }

        if (back_img_url) {
            banner_back_url = `url('${apiConstant.bannerURL(
                back_img_url.file_path
            )}')`;
        }
        return (
            <div id="top_banner">
                <section
                    className={`hero-wrap hero-wrap-2 site-blocks-cover top-image overlay ${
                        this.isHome ? "home-banner" : "middle"
                    }`}
                    ref="top_banner_container"
                    style={{
                        backgroundImage: banner_back_url,
                        backgroundSize: "cover",
                    }}
                    data-stellar-background-ratio="0.5"
                >
                    <div className="container">
                        <div
                            className={`row align-items-center ${
                                this.isHome
                                    ? ""
                                    : "justify-content-center text-center"
                            }`}
                            style={{ zIndex: 1 }}
                        >
                            <div
                                className={`col-md-12 banner-text ${
                                    this.showSearch ? "pt-6" : ""
                                }`}
                            >
                                <h1
                                    className="title mb-3"
                                    data-aos="fade-up"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            this.state.title === undefined ||
                                            this.state.title === null
                                                ? ""
                                                : this.state.title,
                                    }}
                                />
                                <h4
                                    className="sub-title"
                                    data-aos="fade-up"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            this.state.sub_title ===
                                                undefined ||
                                            this.state.sub_title === null
                                                ? ""
                                                : this.state.sub_title,
                                    }}
                                />
                                {this.isHome && (
                                    <span
                                        className="btn btn-primary"
                                        onClick={() => this.onClickAbout()}
                                        data-aos="fade-up"
                                    >
                                        {lang("introdution")}
                                    </span>
                                )}
                                {this.showSearch && (
                                    <div
                                        className="form-search-wrap"
                                        data-aos="fade-up"
                                        data-aos-delay="200"
                                    >
                                        <div className="row align-items-center">
                                            <div className="col-lg-12 form-control-container mb-xl-0 col-xl-5">
                                                <input
                                                    type="text"
                                                    className="form-control rounded"
                                                    id="search_key_editor"
                                                    placeholder={lang(
                                                        "input_search"
                                                    )}
                                                    onChange={
                                                        this.onHandleKeyChange
                                                    }
                                                    onKeyDown={
                                                        this.onHandleKeyDown
                                                    }
                                                    value={
                                                        this.props.topBanner
                                                            .searchKey
                                                    }
                                                />
                                            </div>
                                            <div className="col-lg-12 form-control-container mb-xl-0 col-xl-3">
                                                <div className="select-wrap">
                                                    <select
                                                        className="form-control rounded"
                                                        name=""
                                                        id="bs_selector"
                                                        onChange={
                                                            this.onBsChange
                                                        }
                                                        value={
                                                            this.state.business
                                                        }
                                                    >
                                                        {// Businesses.indexOf('destination')
                                                        BS_CATEGORY.map(
                                                            (bs, key) => (
                                                                <option
                                                                    value={bs}
                                                                    key={key}
                                                                >
                                                                    {lang(bs)}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 form-control-container mb-xl-0 col-xl-2">
                                                <div className="select-wrap">
                                                    <select
                                                        className="form-control rounded"
                                                        name=""
                                                        id="category_selector"
                                                        onChange={
                                                            this
                                                                .onCategoryChange
                                                        }
                                                        value={
                                                            this.state.category
                                                        }
                                                    >
                                                        {this.props.topBanner.arrCategory.map(
                                                            (category, key) => (
                                                                <option
                                                                    value={
                                                                        category
                                                                    }
                                                                    key={key}
                                                                >
                                                                    {lang(
                                                                        category
                                                                    )}
                                                                </option>
                                                            )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-xl-2 form-control-container ml-auto text-right">
                                                <a
                                                    onClick={() =>
                                                        this.onHandleClick()
                                                    }
                                                    className="btn btn-primary btn-block rounded"
                                                >
                                                    {lang("search")}
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <Modal
                    isOpen={this.state.contentModalIsOpen}
                    onAfterOpen={this.afterContentModal}
                    onRequestClose={this.closeContentModal}
                    style={stepEditStyle}
                    ariaHideApp={false}
                >
                    <div className="custom-modal-header has-back">
                        <button
                            type="button"
                            className="close pull-right"
                            data-dismiss="modal"
                            aria-label="Close"
                            onClick={() => this.closeContentModal()}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3
                            className="title"
                            dangerouslySetInnerHTML={{
                                __html: this.state.aboutInfo.title,
                            }}
                        />
                    </div>
                    <div
                        className="custom-modal-content"
                        dangerouslySetInnerHTML={{
                            __html: this.state.aboutInfo.description,
                        }}
                    />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language,
        topBanner: state.topBanner,
    };
}

export default connect(mapStateToProps)(TopBanner);
